module.exports = __webpack_public_path__ + "static/img/logo_46.4fcd191.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_46.png
// module id = aPAy
// module chunks = 1